import { useContext, useEffect, useState } from "react";
import { IAM_SERVER_TENANT, IAM_SERVER_TENANT_USER_REGIST } from "../../../utils/Config"; 
import { ModalContext } from "../../../utils/modal/ModalProvider";
import styles from "../../../utils/modal/DetailModal.module.css";
import axios from "../../../utils/api/axios";
import { InnocodeButton, InnocodeInput, useDialog } from "@intsoft/innocode-core";


/**
 * 테넌트 유저 권한 변경 모달
 * @param tenantUserId 권한을 바꿀 유저 ID
 * @param onClose 모달 닫기 함수
 * @param onUpdate 변경 후 콜백
 */
export const TenantUserInviteModal = ({tenantId, inviterName, canInvite = true, onSuccess, onClose}) => {
  const { showDialog } = useDialog();
  const [email, setEmail] = useState("");
  const [isSending, setIsSending] = useState(false);
  const {closeModal} = useContext(ModalContext);

  const handleSendInvite = (event) => {
    event?.preventDefault();
    event?.stopPropagation();

    if (isSending) {
      return;
    }

    if (!canInvite) {
      showDialog({
        iconType: "warning",
        type: 'error',
        title: "권한 없음",
        message: "초대 권한은 오너와 관리자만 사용할 수 있습니다.",
        confirmText: "확인",
      });
      return;
    }

    if (!email) {
      showDialog({
          iconType: "warning",
          type: 'error',
          title: "경고",
          message: "이메일 주소를 입력해 주세요.",
          confirmText: "확인",
      }); 
      return;
    }

    // 이메일 정규식 확인
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
      showDialog({
        iconType: "warning",
        type: 'error',
        title: "경고",
        message: "올바른 이메일 주소를 입력해 주세요.",
        confirmText: "확인",
      }); 
      return;
    }
    
    if (!tenantId || !inviterName) {
      showDialog({
        iconType: "warning",
        type: 'error',
        title: "초대 실패",
        message: "현재 사용자 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.",
        confirmText: "확인",
      });
      return;
    }

    setIsSending(true);

    const tenantUrl = `${IAM_SERVER_TENANT}/get/${tenantId}`;
    axios.get(tenantUrl)
      .then((tenantRes) => {
        const url = `${IAM_SERVER_TENANT_USER_REGIST}/email/send`;

        const param = {
          tenantId : tenantId,
          email : email,
          inviter : inviterName,
          tenantName : tenantRes.data.data.tenantName
        }


        return axios.post(url, param, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then((res) => {
            showDialog({
                iconType: "check",
                type: 'info',
                title: "초대 메일 발송",
                message: "초대장을 받은 유저가 수락 후 서비스 가입을 완료하면, 테넌트 유저로 등록됩니다.",
                confirmText: "확인",
            });  
            // onSuccess(); // 후속 처리 (예: 목록 갱신)
          })
          .catch((e) => {
            console.error(e);
            showDialog({
                iconType: "warning",
                type: 'error',
                title: "실패",
                message: "초대 메일 발송 중 오류가 발생했습니다.",
                confirmText: "확인",
            });  
          });
      })
      .catch((e) => {
        console.error(e);
        showDialog({
            iconType: "warning",
            type: 'error',
            title: "오류",
            message: "초대 메일 발송 중 오류가 발생했습니다.",
            confirmText: "확인",
        }); 
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  return (
    <div>
      <ul className={styles.layer__listWrap}>
        <li className={styles.layer__list}>
          <p className={styles.layer__listDesc}>테넌트 유저 초대장을 보낼 메일 주소를 입력해 주세요.</p>
        </li>
        <li className={styles.layer__list}>
          <InnocodeInput 
            type="email"
            placeholder="Email 주소"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleSendInvite();
              }
            }}
          />
        </li>
      </ul>
      <div className={styles.layer__saveBtnBox}>  
          <InnocodeButton
            type="button"
            size="md"
            designType="primary" 
            fullWidth={true}
            className={styles.layer__saveBtn}
            disabled={isSending}
            onClick={handleSendInvite}
            disabled={!canInvite}
        >전송</InnocodeButton>
      </div>
      {/* <button className={styles.layer__saveBtn} onClick={handleSendInvite}>전송</button> */}
    </div>
  );
};
